export const ruler = {
  name: "ruler" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M2.1 3a.9.9 0 0 1 .9-.9h6a.9.9 0 0 1 .9.9v11.1H21a.9.9 0 0 1 .9.9v6a.9.9 0 0 1-.9.9H3a.9.9 0 0 1-.9-.9V3Zm6 12.9V17a.9.9 0 0 0 1.8 0v-1.1h1.2V18a.9.9 0 0 0 1.8 0v-2.1h1.2V17a.9.9 0 0 0 1.8 0v-1.1h1.2V18a.9.9 0 0 0 1.8 0v-2.1h1.2v4.2H3.9V3.9h4.2v1.2H6a.9.9 0 1 0 0 1.8h2.1v1.2H7a.9.9 0 1 0 0 1.8h1.1v1.2H6a.9.9 0 1 0 0 1.8h2.1v1.2H6.5a.9.9 0 1 0 0 1.8h1.6Z" clip-rule="evenodd"/></svg>`,
  keywords: ["ruler"],
  category: "other" as const,
};
